import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Grid, Table, TableCell, TableHead, TableRow, Typography, useTheme } from '@material-ui/core';
import { ImcGenericStyle } from '../ImcGeneric/ImcGenericStyle';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import { getAlcGrafic } from '../../domain/api/AlcoholimetriaApi';
import { FaRegAddressCard } from "react-icons/fa6";
import { HiDevicePhoneMobile } from "react-icons/hi2";
import { useDispatch } from 'react-redux';
import { Store } from 'react-notifications-component';
import AlcFilter from './alcFilter';
import { Paper } from '@material-ui/core';
import clsx from 'clsx';
import { UtilsDate } from '../../../app/orussystem/utils/UtilDate';
import { FaGlassWaterDroplet } from "react-icons/fa6";
import { MdCalendarMonth } from "react-icons/md";
import AlcRP from './alcRP';
import AcTotales from './alcTotales';
import '../GeneriBascula.js/graficas.css'
import { panelUsersAuthStyle } from '../../users_auth/panelUsersAuthStyle';
import GraficaAlcohol from './GraficaAlcohol';

export const Alcoholimetria = (props) => {

  const classes = ImcGenericStyle();
  const dispatch = useDispatch();
  const [dataEnd, setDataEnd] = useState(UtilsDate().formatYYYYMMdd(new Date()));
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  let { id } = useParams();
  const { nombre } = location.state;

  const idBascula = id === undefined || id === null || id === ":id" || id === "poll" ? 7 : id;

  const [dataPositivo, setDataPositivo] = useState([]);
  const [dataNegativo, setDataNegativo] = useState([]);
  const [dataTotal, setDataTotal] = useState([]);
  const [, setAlcGrafic] = useState([]);
  const [alcGrafic2, setAlcGrafic2] = useState([]);
  const [alcTablaRP, setAlcTablaRP] = useState([]);
  const [positivos, setPositivos] = useState([]);

  const clases = panelUsersAuthStyle()

  const fixedHeightFilter = clsx(classes.paper, classes.fixedHeightFilter);
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [imcTotalGrafic, setImcTotalGrafic] = useState([]);


  const [isLoadUser, setIsLoadUser] = useState(false);
  //fecha inicial
  const originalDateIni = new Date();
  const yearIni = originalDateIni.getFullYear();
  const monthIni = originalDateIni.getMonth();
  const dayIni = originalDateIni.getDate();
  const dateIni = `${yearIni}-${monthIni.toString().padStart(2, '0')}-${dayIni.toString().padStart(2, '0')}`;
  const [dataStart, setDataStart] = useState(dateIni);

  useEffect(async () => {

    consulta(dateIni, dataEnd)

  }, []);


  // METODO PARA CREAR ALERTA
  const handledAlert = (title, message, type) => {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true
      }
    });
    setTimeout(() => {

    }, 1000);
  }

  // Organizar y setear datos de ALCOHOLIMETRIA
  const dataOrganizationAL = (AL) => {

    let dataPieAL = []
    let contNegativoAL = 0;
    let contPositivoAL = 0;

    AL.map((item) => {
      contNegativoAL += item[0]?.rango === '1' ? item[0].count : item[1]?.rango === '1' ? item[1].count : 0;
      contPositivoAL += item[1]?.rango === '2' ? item[1].count : item[0].rango === '2' ? item[0].count : 0;
    })

    dataPieAL.push(
      {
        name: "Negativo",
        value: contNegativoAL
      },
      {
        name: "Positivo",
        value: contPositivoAL
      }

    )
    setAlcGrafic2(dataPieAL)
  }


  const consulta = async (dataStartParam, dataEndParam) => {

    {
      {/**DATOS TARJETA ALCOHOLIMETRÍA */ }
      const alcoholimetria = await getAlcGrafic(dispatch, idBascula, dataStartParam, dataEndParam);

      const negativo = (alcoholimetria.respuesta?.countUsers[0]?.rango === '1' ? alcoholimetria.respuesta?.countUsers[0].count : alcoholimetria.respuesta?.countUsers[1]?.rango === '1' ? alcoholimetria.respuesta?.countUsers[1]?.count : 0 || 0);
      const positivo = (alcoholimetria.respuesta?.countUsers[1]?.rango === '2' ? alcoholimetria.respuesta?.countUsers[1].count : alcoholimetria.respuesta?.countUsers[0]?.rango === '2' ? alcoholimetria.respuesta?.countUsers[0]?.count : 0 || 0);
      const total = (alcoholimetria.respuesta?.totalusers || 0);



      setIsLoading(false);
      // Capturar errores en las llamadas al api
      try {
        setDataNegativo(negativo)
        setDataPositivo(positivo)
        setDataTotal(total)
        setAlcGrafic([alcoholimetria.respuesta.countUsers])
        dataOrganizationAL([alcoholimetria.respuesta.countUsers])

        setPositivos(alcoholimetria.respuesta.usersPositivo)
        setAlcTablaRP(alcoholimetria.respuesta.generics)

      } catch (err) {



      }

    }

  }
  // SETEAR FECHAS A FILTRO
  const handlerFilter = (dataStart, dataEnd) => {
    setDataEnd(UtilsDate().formatYYYYMMdd(dataEnd));
    setDataStart(UtilsDate().formatYYYYMMdd(dataStart))
    busqueda(UtilsDate().formatYYYYMMdd(dataStart), UtilsDate().formatYYYYMMdd(dataEnd))
  };
  const busqueda = (dataStart, dataEnd) => {
    consulta(dataStart, dataEnd)
  }

  const theme = useTheme(); // Obtén el tema

  const primaryColor = theme.palette.primary.main;


  return (
    <>

      <Grid item xs={12} >
        <br></br>
        <br></br>

        <MigaPan
          namePage={`Alcoholimetría ${nombre}`}
          to="/"
          namePage2="Estaciones"
          to2="/basculas/"
        >
          Home
        </MigaPan>
      </Grid>

      <Grid item xs={12} md={12} lg={12}>
        <Paper className={fixedHeightFilter} style={{ overflow: 'hidden', }}>
          <AlcFilter
            handlerFilter={handlerFilter}
            isLoading={isLoading}
            isDate={false}
            titlePanel={`Estación de ${nombre}`}
            idBascula={idBascula}
            total={dataTotal}
            nameBascula={nombre}
            dataStartParam={dataStart}
            dataEndParam={dataEnd}
          />

        </Paper>
      </Grid>
      <Grid item xs={9} >
        <Paper style={{ borderRadius: '20px', height: '105%', width: '100%' }}>
          <GraficaAlcohol
            negativos={dataNegativo}
            positivos={dataPositivo}
            total={dataTotal}
            totalPositivos={'Total de usuarios'}
          ></GraficaAlcohol>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper className={fixedHeightPaper}>
          <AcTotales data={imcTotalGrafic}
            totalPositivos={'Total de usuarios positivos'}
            positivo={dataPositivo} />
        </Paper>
      </Grid>

      <Grid item xs={12} md={6} lg={12}>
        <Paper className={fixedHeightPaper}>
          <Typography align="center" style={{ fontWeight: 'bold', fontSize: "26px" }} color='primary' >
            Registros Positivos
          </Typography>
          <Grid item xs={12}>
            <Table>
              <TableHead style={{ color: '#0088FE' }}>
                <TableRow style={{ color: '#0088FE' }}>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '20%', color: primaryColor }}><FaRegAddressCard style={{ marginBottom: '-2%', marginRight: '3%', fontSize: '22px' }} />Identificacion</TableCell>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '8%', width: '20%', color: primaryColor }}><HiDevicePhoneMobile style={{ marginBottom: '-2%', marginRight: '3%', fontSize: '22px' }} />Celular</TableCell>
                  <TableCell className={clases.TableCell} style={{ width: '25%', paddingLeft: '7%', color: primaryColor }}><FaGlassWaterDroplet style={{ marginBottom: '-2%', marginRight: '3%', fontSize: '22px' }} />Medición</TableCell>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', color: primaryColor }}><MdCalendarMonth style={{ marginBottom: '-2%', marginRight: '3%', fontSize: '22px' }} />Fecha de Registro</TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </Grid>
          <Grid item xs={12}>
            <AlcRP
              data={alcTablaRP}
              isLoadUser={isLoadUser}
              positivos={positivos} />
          </Grid>
        </Paper>
      </Grid>

    </>
  );
}

